import demographicReducer from './reducers';
export { default as demographicOperations } from './operations';
export { default as demographicTypes } from './types';
export default demographicReducer;
